import Enum from "@/util/enum";
import EnumValue from ".";

export default class DonorType extends Enum {
  static UNKNOWN: EnumValue = { name: "Unknown", code: 0 };
  static CBU: EnumValue = { name: "CB", code: 1 };
  static MARROWDONOR: EnumValue = { name: "MD", code: 2 };
}
